/**
 * 用户服务
 * 需要登录后才能调用
 */

const GIFT_CARD_API = {
  CHECK: '/api/v1/user/gift-card/check',
  REDEEM: '/api/v1/user/gift-card/redeem'
}

/**
 * 获取订阅信息
 */
export async function getSubscribe(api) {
  return api.call('/api/v1/user/getSubscribe')
}

/**
 * 获取用户信息
 */
export async function getUserInfo(api) {
  return api.call('/api/v1/user/info')
}

/**
 * 修改密码
 */
export async function changePassword(api, old_password, new_password) {
  return api.call('/api/v1/user/changePassword', 'POST', { old_password, new_password })
}

/**
 * 重置订阅信息
 */
export async function resetSubscription(api) {
  return api.call('/api/v1/user/resetSecurity', 'GET')
}

/**
 * 获取通用配置
 */
export async function getCommonConfig(api) {
  return api.call('/api/v1/user/comm/config')
}

/**
 * 更新用户设置
 */
export async function updateUserSettings(api, settings) {
  return api.call('/api/v1/user/update', 'POST', settings)
}

/**
 * 佣金划转
 */
export async function transferCommission(api, amount) {
  return api.call('/api/v1/user/transfer', 'POST', { transfer_amount: amount })
}

/**
 * 查询礼品卡/兑换码奖励预览
 */
export async function checkGiftCard(api, code) {
  return api.call(GIFT_CARD_API.CHECK, 'POST', { code })
}

/**
 * 兑换礼品卡/兑换码
 */
export async function redeemGiftCard(api, code) {
  return api.call(GIFT_CARD_API.REDEEM, 'POST', { code })
}

export default {
  getSubscribe,
  getUserInfo,
  changePassword,
  resetSubscription,
  getCommonConfig,
  updateUserSettings,
  transferCommission,
  checkGiftCard,
  redeemGiftCard,
}
